import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import DeleteDialogStyle from "styles/application/DeleteDialogStyle";
import LocalePicker from "components/Elements/LocalePicker";
import { localeOptions } from "helpers/localeOptions";

const ADD = DeleteDialogStyle();

const TranslationDialog = ({ open, closeHandler, onStart, isTranslating }) => {
	const { t } = useTranslation();
	const [locale, setLocale] = useState(localeOptions[0] ?? null);

	useEffect(() => {
		if (!open) {
			setLocale(localeOptions[0] ?? null);
		}
	}, [open]);

	const handleStart = () => {
		if (!locale) return;
		// Keep the parent's expected shape: { language: { value, label },
		// country: { value, label } }. The picker hands us a locale object
		// with both pieces already split.
		onStart?.({
			language: { value: locale.language, label: locale.languageLabel },
			country: { value: locale.country, label: locale.countryLabel },
		});
	};

	return (
		<Dialog
			open={open}
			onClose={closeHandler}
			aria-labelledby="translation-title"
			aria-describedby="translation-description"
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle id="translation-title" sx={{ pb: 0 }}>
				<ADD.HeaderText>{t("title.startTranslation")}</ADD.HeaderText>
			</DialogTitle>
			<DialogContent sx={{ pt: "12px !important" }}>
				<Typography
					id="translation-description"
					sx={{ color: "#393939", mb: 2.5 }}
				>
					{t("message.pickDestinationLanguage")}
				</Typography>
				<LocalePicker
					value={locale}
					onChange={setLocale}
					required
					helperText={t("message.typeLanguageOrCountry")}
				/>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 3 }}>
				<ADD.DeleteButton
					onClick={closeHandler}
					variant="contained"
					disabled={isTranslating}
				>
					{t("action.cancel")}
				</ADD.DeleteButton>
				<ADD.CancelButton
					onClick={handleStart}
					variant="contained"
					disabled={isTranslating || !locale}
				>
					{isTranslating
						? t("label.translatingEllipsis")
						: t("title.startTranslation")}
				</ADD.CancelButton>
			</DialogActions>
		</Dialog>
	);
};

export default TranslationDialog;
